module.exports = new __parcel__URL__("shadowresistance.393d8f02.png").toString();